import axios from '@/lib/axios';
import { FacilityLensOrderParams } from '../types';

const confirmFacilityLens = (data: FacilityLensOrderParams) => {
  return axios.post('/facility/orders/facility_lens/confirm', data);
}

export default confirmFacilityLens;